import { observable, action, runInAction } from "mobx";
import { Dialog } from "@weapp/ui";
import { getLabel } from "@weapp/utils";

import * as LoginAPI from '../../../api/pc/login';
import { loginParamsType } from "./type";
import { publicUrl } from "../../../constants";
import { getQueryString } from "../../../utils";

// import * as API from "../../../api/pc/list";

const { message } = Dialog;

export class AdminLoginStore {

  routePush: any = null;
  //初始数据
  @action
  init = (routePush: any) => {
    this.routePush = routePush;
  }

  //登录
  @action
  getLogin = (loginParams: loginParamsType) => {
    LoginAPI.adminLogin(loginParams).then((result: any) => {
      if (result?.data?.errorMsg) {
        const msg = result.data.errorMsg
        message({
          type: "error",
          content: getLabel(msg.i18nId, msg.msg),
          delay: 2000
        });
      } else {
        //登录成功--有团队
        if (result?.data?.redirectUrl) {

          window.sessionStorage.setItem('E10_PASSPORT_ADMINLOGIN_ADDR', window.location.href);

          let detachTk = getQueryString('detachTk');

          //直接跳转至
          window.location.href = result.data.redirectUrl +
            '&service=' + encodeURIComponent(`${window.passport_runInfo.weappUrl}${publicUrl}/info`) +
            (detachTk ? `&detachTk=${detachTk}` : '');
        }
      }
    });
  }

}

const instance = new AdminLoginStore();

export default instance;
export type AdminLoginStoreType = Pick<AdminLoginStore, keyof AdminLoginStore>;
